import React from "react";
import MultiPanelOffcanvas from "../../common/features/multiPanelOffcanvas/components/MultiPanelOffcanvas";
import SearchPanel from "../../templates/ecommerce/product/components/SearchPanel/SearchPanel";
import CartPanel from "../../templates/ecommerce/cart/components/CartPanel/CartPanel";
import WishlistPanel from "../../templates/ecommerce/wishlist/components/WishlistPanel/WishlistPanel";

/**
 * AppPanels Component
 *
 * This is a "smart" composition component responsible for assembling the global off-canvas panels.
 * It imports the specific panels (Cart, Search) and injects them into the generic
 * MultiPanelOffcanvas container. This component is hydrated once in the footer.
 */
const AppPanels: React.FC = () => {
  return (
    <MultiPanelOffcanvas
      searchPanel={<SearchPanel />}
      cartPanel={<CartPanel />}
      wishlistPanel={<WishlistPanel />}
    />
  );
};

export default AppPanels;
